import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const mentalMapItems = [{
  id: "plantacao-igrejas",
  title: "Plantação de igrejas",
  text: "Plantação de igrejas em locais pouco evangelizados",
  extra: "Buscamos plantar comunidades saudáveis que sejam faróis do evangelho em lugares pouco alcançados.",
  verse: "Portanto ide, fazei discípulos de todas as nações (Mateus 28:19)",
  position: "lg:left-[2%] lg:top-[8%]",
  delayClass: "anim-delay-1"
}, {
  id: "cursos-cidades",
  title: "Cursos em pequenas cidades",
  text: "Levar cursos profissionalizantes para pequenas cidades",
  extra: "Oferecemos capacitação para que famílias possam caminhar com mais dignidade e autonomia.",
  verse: "Ensina a criança no caminho em que deve andar (Provérbios 22:6)",
  position: "lg:left-[32%] lg:top-[16%]",
  delayClass: "anim-delay-2"
}, {
  id: "debates-lideres",
  title: "Debates com líderes",
  text: "Promover debates com intuito de incentivar líderes evangélicos a trabalharem com a sã doutrina",
  extra: "Reunimos pastores e líderes para refletirem juntos sobre fidelidade bíblica e cuidado com o rebanho.",
  verse: "Retenha a fiel palavra, que é conforme a doutrina (Tito 1:9)",
  position: "lg:left-[62%] lg:top-[6%]",
  delayClass: "anim-delay-3"
}, {
  id: "palestras-carentes",
  title: "Palestras em comunidades",
  text: "Promover palestras educacionais em comunidades carentes",
  extra: "Levamos conteúdos que fortalecem famílias, jovens e crianças em temas práticos do dia a dia.",
  verse: "O meu povo é destruído, porque lhe falta o conhecimento (Oséias 4:6)",
  position: "lg:left-[72%] lg:top-[30%]",
  delayClass: "anim-delay-1"
}, {
  id: "apoiar-congregacoes",
  title: "Apoiar congregações",
  text: "Apoiar ministerialmente congregações com poucos recursos e pequenos ministérios",
  extra: "Servimos igrejas parceiras com apoio pastoral, ensino e presença constante.",
  verse: "Levai as cargas uns dos outros (Gálatas 6:2)",
  position: "lg:left-[10%] lg:top-[55%]",
  delayClass: "anim-delay-2"
}, {
  id: "mutiroes-sociais",
  title: "Mutirões sociais",
  text: "Promover mutirões de ação social em locais carentes",
  extra: "Unimos forças para cuidar de necessidades urgentes, servindo com amor e excelência.",
  verse: "A fé sem obras é morta (Tiago 2:17)",
  position: "lg:left-[42%] lg:top-[70%]",
  delayClass: "anim-delay-3"
}, {
  id: "empreendimentos",
  title: "Empreendimentos familiares",
  text: "Incentivar a criação de empreendimentos familiares",
  extra: "Ajudamos famílias a desenvolverem pequenos negócios que gerem renda e sustentabilidade.",
  verse: "Confia ao Senhor as tuas obras, e os teus pensamentos serão estabelecidos (Provérbios 16:3)",
  position: "lg:left-[72%] lg:top-[68%]",
  delayClass: "anim-delay-1"
}] as const;

/* MAPA MENTAL TRADICIONAL 2026 */
const MapaMentalPerfeito = () => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  return <section className="mt-20">
      <header className="mb-8 max-w-3xl space-y-2">
        <p className="section-title">Mapa mental da missão</p>
        <h2 className="section-heading">Como colocamos a missão em prática.</h2>
        <p className="section-subtitle">
          Visualize, em um único mapa, as principais frentes de atuação do Instituto – todas conectadas ao coração
          das nossas atividades.
        </p>
      </header>

      {/* Desktop: mapa mental tradicional */}
      <div className="relative hidden min-h-[950px] max-w-[1600px] animate-fade-in rounded-[2.5rem] border border-white/10 bg-[radial-gradient(circle_at_0%_0%,_hsl(var(--halo-deep))_0,_transparent_55%),_radial-gradient(circle_at_100%_0%,_hsl(var(--primary))_0,_transparent_60%)] px-6 py-20 shadow-[0_40px_120px_hsl(var(--neutral-black)_/_0.9)] lg:block lg:px-10">
        {/* SVG de conexões */}
        <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          {mentalMapItems.map(item => {
          const lineBaseClasses = "transition-all duration-200 ease-out drop-shadow-[0_0_12px_rgba(79,70,229,0.6)]";
          const isActive = hoveredId === item.id;
          const coords: Record<string, {
            x2: number;
            y2: number;
          }> = {
            "plantacao-igrejas": {
              x2: 9,
              y2: 16
            },
            "cursos-cidades": {
              x2: 37,
              y2: 24
            },
            "debates-lideres": {
              x2: 70,
              y2: 15
            },
            "palestras-carentes": {
              x2: 80,
              y2: 40
            },
            "apoiar-congregacoes": {
              x2: 17,
              y2: 63
            },
            "mutiroes-sociais": {
              x2: 48,
              y2: 80
            },
            empreendimentos: {
              x2: 77,
              y2: 70
            }
          };
          const {
            x2,
            y2
          } = coords[item.id];
          return <line key={item.id} x1="50" y1="50" x2={x2} y2={y2} className={lineBaseClasses} style={{
            stroke: isActive ? "hsl(var(--secondary))" : "hsl(var(--primary))",
            strokeWidth: isActive ? 6 : 4,
            opacity: 0.75,
            filter: isActive ? "drop-shadow(0 0 18px hsl(var(--secondary) / 0.9))" : "drop-shadow(0 0 10px hsl(var(--primary) / 0.7))",
            transition: "stroke 0.2s ease-out, stroke-width 0.2s ease-out, filter 0.2s ease-out"
          }} />;
        })}
        </svg>

        {/* Card central ATIVIDADES */}
        <div className="absolute left-1/2 top-1/2 flex h-[200px] w-[300px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-[24px] border border-white/25 text-center text-4xl font-bold tracking-tight text-white shadow-[0_25px_50px_-18px_hsl(var(--neutral-black)_/_0.9)] backdrop-blur-[25px]" style={{
        backgroundImage: "linear-gradient(135deg, hsl(var(--primary) / 0.96) 0%, hsl(var(--secondary) / 0.92) 100%)"
      }}>
          <span className="drop-shadow-[0_12px_25px_rgba(15,23,42,0.9)]">ATIVIDADES</span>
        </div>

        {/* Cards filhos */}
        {mentalMapItems.map((item, index) => <Dialog key={item.id}>
            <DialogTrigger asChild>
              <button type="button" className={`card-ambient group absolute h-[160px] w-[250px] cursor-pointer rounded-[20px] border border-white/50 bg-white/90 p-6 text-left text-[13.5px] leading-relaxed shadow-[0_15px_35px_rgba(15,23,42,0.25)] backdrop-blur-[20px] transition-transform duration-200 ease-out hover:-translate-y-1 hover:scale-[1.07] hover:rotate-1 hover:shadow-[0_25px_55px_rgba(15,23,42,0.35)] ${item.position} ${item.delayClass} animate-fade-in`} onMouseEnter={() => setHoveredId(item.id)} onMouseLeave={() => setHoveredId(current => current === item.id ? null : current)} onFocus={() => setHoveredId(item.id)} onBlur={() => setHoveredId(current => current === item.id ? null : current)}>
                <p className="mb-1 text-xs font-semibold uppercase tracking-[0.22em] text-primary">
                  Frente de atuação
                </p>
                <h3 className="mb-2 text-sm font-semibold text-slate-900">{item.title}</h3>
                <p className="text-[13px] text-muted-foreground">{item.text}</p>
              </button>
            </DialogTrigger>

            <DialogContent className="max-w-lg border border-primary/20 bg-background/95 backdrop-blur-xl">
              <DialogHeader>
                <DialogTitle>{item.title}</DialogTitle>
                <DialogDescription>{item.text}</DialogDescription>
              </DialogHeader>
              <div className="mt-4 space-y-3 text-sm text-muted-foreground">
                <p>{item.extra}</p>
                <p className="text-xs font-medium uppercase tracking-[0.18em] text-primary/80">
                  {item.verse}
                </p>
              </div>
              <div className="mt-4 space-y-3 text-sm text-muted-foreground">
                <p>{item.extra}</p>
                <p className="text-xs font-medium uppercase tracking-[0.18em] text-primary/80">
                  {item.verse}
                </p>
              </div>
            </DialogContent>
          </Dialog>)}
      </div>

      {/* Mobile / tablet: lista vertical */}
      <div className="mt-10 space-y-6 lg:hidden">
        <div className="rounded-3xl bg-[radial-gradient(circle_at_0%_0%,_hsl(var(--halo-deep))_0,_transparent_55%),_radial-gradient(circle_at_100%_0%,_hsl(var(--primary))_0,_transparent_60%)] p-6 text-center text-white shadow-[0_30px_80px_hsl(var(--neutral-black)_/_0.9)]">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sidebar">Núcleo da missão</p>
          <h3 className="mt-2 text-2xl font-bold text-sidebar">ATIVIDADES</h3>
          <p className="mt-3 text-sm text-sidebar">
            As ações abaixo se conectam ao nosso propósito central de servir com o evangelho e com amor prático.
          </p>
        </div>

        <div className="space-y-6">
          {mentalMapItems.map((item, index) => <Dialog key={item.id}>
              <DialogTrigger asChild>
                <button type="button" className="group flex w-full items-start gap-3 rounded-2xl border border-white/40 bg-white/95 p-4 text-left text-[13.5px] leading-relaxed shadow-[0_12px_30px_rgba(15,23,42,0.18)] backdrop-blur-[18px] transition-transform duration-200 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(15,23,42,0.25)]">
                  <div className="mt-1 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary shadow-inner">
                    <span className="group-hover:scale-110 transition-transform">{index + 1}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="mb-1 text-sm font-semibold text-slate-900">{item.title}</h3>
                    <p className="text-[13px] text-muted-foreground">{item.text}</p>

                    <div className="mt-3 flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-primary">
                      <span className="h-[1px] w-8 bg-primary/50" aria-hidden="true" />
                      
                    </div>
                  </div>
                </button>
              </DialogTrigger>

              <DialogContent className="max-w-lg border border-primary/20 bg-background/95 backdrop-blur-xl">
                <DialogHeader>
                  <DialogTitle>{item.title}</DialogTitle>
                  <DialogDescription>{item.text}</DialogDescription>
                </DialogHeader>
              </DialogContent>
            </Dialog>)}
        </div>
      </div>
    </section>;
};
const Missao = () => {
  return <section className="section-shell">
      <header className="mb-10 max-w-3xl space-y-3">
        <p className="section-title">Missão</p>
        <h1 className="section-heading">Por que existimos.</h1>
        <p className="section-subtitle">
          O Instituto Evangelístico e Social Sabedoria do Alto nasce do desejo de ver o evangelho alcançando pessoas
          integralmente – espírito, alma e corpo – com atenção especial às regiões menos assistidas do nosso país.
        </p>
      </header>

      <div className="grid gap-10 md:grid-cols-3">
        <article className="card-ambient p-6 md:col-span-1">
          <h2 className="mb-3 text-lg font-semibold">Missão</h2>
          <p className="text-sm text-muted-foreground">
            Plantar o evangelho e regar esperança através da proclamação da Palavra, do cuidado pastoral e de ações
            sociais consistentes, formando discípulos que amam a Deus e servem ao próximo.
          </p>
        </article>

        <article className="card-ambient p-6">
          <h2 className="mb-3 text-lg font-semibold">Visão</h2>
          <p className="text-sm text-muted-foreground">
            Ser referência em missão integral, especialmente no contexto da Caatinga, inspirando igrejas e líderes a
            viverem uma espiritualidade bíblica, sensível às realidades de sofrimento e fome de esperança.
          </p>
        </article>

        <article className="card-ambient p-6">
          <h2 className="mb-3 text-lg font-semibold">Valores</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Centralidade das Escrituras e da pessoa de Jesus Cristo.</li>
            <li>• Dependência do Espírito Santo em cada decisão e projeto.</li>
            <li>• Amor prático pelos pobres, vulneráveis e esquecidos.</li>
            <li>• Transparência, serviço e parceria com a igreja local.</li>
          </ul>
        </article>
      </div>

      <div className="mt-12 grid gap-8 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-center">
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold">Evangelístico e social – inseparáveis.</h2>
          <p className="text-sm text-muted-foreground">
            Proclamamos com clareza o evangelho de Cristo, ao mesmo tempo em que enxergamos a realidade concreta das
            pessoas. A fé que anunciamos precisa alcançar mesas vazias, corações cansados e comunidades marcadas pela
            seca e pela desigualdade.
          </p>
          <p className="text-sm text-muted-foreground">
            Por isso unimos discipulado, cuidado pastoral e ações sociais planejadas, sempre em parceria com igrejas e
            líderes locais.
          </p>
        </div>
        <div className="card-ambient h-full p-6">
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary">Ênfase espiritual</p>
          <p className="text-sm text-muted-foreground">
            Cremos que toda transformação verdadeira nasce do encontro com Jesus. Nossos cultos, rodas de conversa,
            estudos bíblicos e atendimentos pastorais são conduzidos com reverência, simplicidade e profundo respeito
            às pessoas.
          </p>
        </div>
      </div>

      <MapaMentalPerfeito />
    </section>;
};
export default Missao;